(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

// GF helper
jQuery.noConflict();
jQuery(function () {
  jQuery(document).on('gform_post_render', function (event, form_id, current_page) {
    if (document.querySelectorAll('.js-custom-select').length) {
      Array.prototype.forEach.call(document.querySelectorAll('.js-custom-select'), function (item) {
        var customSlectItem = new CustomSelect(item);

        if (customSlectItem.select.value) {
          customSlectItem.label.innerText = customSlectItem.select.value;
        }
      });
    }

    if (document.querySelectorAll('.ginput_container_textarea textarea').length) {
      var textareas = document.querySelectorAll('.ginput_container_textarea textarea');

      var autosize = function autosize(e) {
        var el = this;
        setTimeout(function () {
          el.parentNode.style.cssText = 'height:' + el.scrollHeight + 'px';
          el.style.cssText = 'height:' + el.scrollHeight + 'px';
        }, 0);
      };

      Array.prototype.forEach.call(textareas, function (item) {
        return item.addEventListener('keydown', autosize);
      });
    }
  });
  var InputIsEmpty = {
    init: function init() {
      var $items = jQuery('.js-submission-form .gfield--name input,' + '.js-submission-form .gfield--email input,' + '.js-submission-form .gfield--phone input,' + '.js-submission-form .gfield--text input,' + '.js-submission-form .gfield--textarea textarea');
      $items.on('focusin', function (e) {
        var $target = jQuery(e.currentTarget);
        $target.closest('.gfield').addClass('not-empty');
      });
      $items.on('focusout', function (e) {
        var $target = jQuery(e.currentTarget);
        if (!$target.val()) $target.closest('.gfield').removeClass('not-empty');
      });
    }
  };
  jQuery(document).on('gform_post_render', function () {
    InputIsEmpty.init();
  }); // Handle file upload label

  gform.addAction('gform_input_change', function (elem, formId, fieldId) {
    //do something
    if ('file' === elem.type && elem.value) {
      var fullPath = elem.value,
          startIndex = fullPath.indexOf('\\') >= 0 ? fullPath.lastIndexOf('\\') : fullPath.lastIndexOf('/');
      var filename = fullPath.substring(startIndex);

      if (filename.indexOf('\\') === 0 || filename.indexOf('/') === 0) {
        filename = filename.substring(1);
        jQuery(elem).closest('.gfield').find('label').text(filename);
      }
    }
  }, 10, 3); // In form accordion

  jQuery(document).on('gform_post_render', function () {
    if (document.querySelectorAll('.js-accordion-trigger').length) {
      Array.prototype.forEach.call(document.querySelectorAll('.js-accordion-trigger'), function (item) {
        var target = null;

        if (target = item.parentNode.querySelector('.js-accordion-target')) {
          item.addEventListener('click', function (e) {
            e.preventDefault();

            if (target.classList.contains('active')) {
              target.classList.remove('active');
            } else {
              target.classList.add('active');
            }
          });
        }
      });
    }
  });
});

},{}]},{},[1]);
